import { Checkbox as CheckboxPrimitive } from 'radix-ui'
import * as React from 'react'
import { LuCheck } from 'react-icons/lu'

import { cn } from '@/lib/utils'

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        `peer border-input focus-visible:border-ring focus-visible:ring-ring/50
        aria-invalid:border-destructive aria-invalid:ring-destructive/20
        data-[state=checked]:border-primary data-[state=checked]:bg-primary
        data-[state=checked]:text-primary-foreground size-4 shrink-0
        rounded-[4px] border bg-white shadow-xs transition-shadow outline-none
        focus-visible:ring-[3px] disabled:cursor-not-allowed
        disabled:opacity-50`,
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <LuCheck className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
